import * as React from 'react';
import { Edit, SimpleForm, TextInput, DateInput, required } from 'react-admin';

export const CouponEdit = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput disabled source="id" validate={[required()]} />
        <TextInput disabled source="code" validate={[required()]} />
        <TextInput
          source="name"
          label="Name/Description"
          validate={[required()]}
        />
        <TextInput
          source="maxTimes"
          label="Max times to use"
          validate={[required()]}
        />
        <TextInput disabled source="productId" validate={[required()]} />
        <DateInput source="startAt" validate={[required()]} />
        <DateInput source="expiredAt" validate={[required()]} />
      </SimpleForm>
    </Edit>
  );
};
